export type PriorityCasinoFilters = {
  country?: string;
  license?: string;
  minRating?: number;
};

function slugify(value: string): string {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function deSlugify(value: string): string {
  const raw = String(value ?? '').trim().replace(/-+/g, ' ');
  if (!raw) return '';
  if (/^[a-z]{2,3}$/i.test(raw)) return raw.toUpperCase();
  return raw.replace(/\b[a-z]/g, (m) => m.toUpperCase());
}

export function buildPriorityFilterSegments(filters: PriorityCasinoFilters): string[] {
  const segments: string[] = [];
  const country = slugify(String(filters.country ?? ''));
  const license = slugify(String(filters.license ?? ''));
  const minRating = Number(filters.minRating ?? 0);

  if (country) segments.push(country);
  if (license) segments.push(`license-${license}`);
  if (Number.isFinite(minRating) && minRating > 0) {
    const normalized = String(minRating).replace(/\.0+$/, '').replace('.', '-');
    segments.push(`rating-${normalized}`);
  }
  return segments;
}

export function parsePriorityFiltersFromSegments(segments: string[]): PriorityCasinoFilters {
  const out: PriorityCasinoFilters = {};
  const safeSegments = Array.isArray(segments) ? segments : [];

  for (const segment of safeSegments) {
    const value = String(segment ?? '').trim().toLowerCase();
    if (!value) continue;

    if (value.startsWith('license-')) {
      out.license = deSlugify(value.slice('license-'.length));
      continue;
    }
    if (value.startsWith('rating-')) {
      const parsed = Number(value.slice('rating-'.length).replace(/-/g, '.'));
      if (Number.isFinite(parsed) && parsed > 0) out.minRating = parsed;
      continue;
    }
    if (!out.country) {
      out.country = deSlugify(value);
    }
  }

  return out;
}
